module.exports = function getResource(label, vars = []) {
    const resources = {
        widgetError: 'Difficulté à se connecter à Afterpay. Veuillez utiliser un autre mode de paiement ou réessayer plus tard.',
        legalNotice: 'En cliquant sur « Continuer vers Afterpay », je demande à Sephora d’envoyer mes renseignements de commande et de facturation à Afterpay et je comprends que ces renseignements seront assujettis aux conditions d’Afterpay et à sa politique de confidentialité.'
    };

    return resources[label];
};
